/**
 * Canonical stored form of a phone number: digits only, with the leading country "1"
 * dropped from an 11-digit US number. Every surface that persists a phone (contact
 * create/edit, shipment snapshot, UPS party) runs the value through this, and display
 * sites format the digits back out (PhoneNumberPipe / ngx-mask / formatUpsPhone).
 * Anything that isn't recognizably US (short, international) keeps its digits as-is
 * rather than being truncated.
 */
export function normalizePhoneNumber(raw: string | null | undefined): string {
    const digits = (raw ?? '').replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
    return digits;
}
